import React, { useContext } from 'react';

import { PagePropsContext } from '../App';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CategoryList from '../components/CategoryList';
import Faqs from '../components/Faqs';

import { isDesktop } from '../utils/functions';

const PageFaq = () => {
  const { categories, selectedCategory, setSelectedCategory } = useContext(PagePropsContext);

  const handleClick = () => {
    if (isDesktop()) {
      setSelectedCategory(null);
      return;
    }

    const category = selectedCategory.parent_category
      ? categories.find(c => c.id === selectedCategory.parent_category)
      : selectedCategory;
    setSelectedCategory(category);
  }

  return selectedCategory && <div className='page page--faq'>
    <Header
      title={selectedCategory.name}
      showBreadcrumb={true}
      showSearch={true}
      onBack={handleClick}
    />
    <div className='page__content'>
      <CategoryList />
      <Faqs />
    </div>
    <Footer />
  </div>;
}

export default PageFaq;